import { TFunction } from "i18next";

import { Button, Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

import { StatusBadge } from "@components";

export const ProcurementDemandListTableColumn = (
  t: TFunction<"translation", undefined>,
  handleSelectedDemand: (id: number) => void,
  demandIds: number[],
  demands: any,
) => {
  const { language } = useLanguage();

  return [
    {
      id: 1,
      key: "name",
      name: t("PROCUREMENT_DEMAND.DEMAND_LIST.TABLE.COLUMN.NAME"),
      render: (name: string) => {
        return (
          <Text color="subtitle1" className="text-nowrap">
            {name}
          </Text>
        );
      },
    },
    {
      id: 2,
      key: "demandRefNo",
      name: t("PROCUREMENT_DEMAND.DEMAND_LIST.TABLE.COLUMN.NUMBER"),
      render: (demandRefNo: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {demandRefNo}
        </Text>
      ),
    },

    {
      id: 4,
      key: "totalApproximateCost",
      name: t("PROCUREMENT_DEMAND.DEMAND_LIST.TABLE.COLUMN.TOTAL_PRICE"),
      render: (totalApproximateCost: number) => (
        <Text color="subtitle1" className="text-nowrap">
          {totalApproximateCost}
        </Text>
      ),
    },

    {
      id: 5,
      key: "status",
      name: t("PROCUREMENT_DEMAND.DEMAND_LIST.TABLE.COLUMN.STATUS"),
      render: (status: string) => {
        return <StatusBadge status={status} />;
      },
    },
    {
      id: 3,
      key: "totalProduct",
      name:
        !demands &&
        t("PROCUREMENT_DEMAND.DEMAND_LIST.TABLE.COLUMN.TOTAL_PRODUCT"),
      render: (totalProduct: number) =>
        !demands ? (
          <Text color="subtitle1" className="text-nowrap">
            {totalProduct}
          </Text>
        ) : null,
    },

    {
      id: 6,
      key: "id",
      name: "",
      render: (id: number) => {
        const handleDemandIds = () => {
          handleSelectedDemand(id);
        };

        return (
          <Button
            size="sm"
            className={
              demandIds.includes(id)
                ? "bg-primary-lighter text-primary"
                : "bg-primary text-white"
            }
            onClick={handleDemandIds}
          >
            {demandIds.includes(id) ? "Remove" : "Select"}
          </Button>
        );
      },
    },
  ];
};
